// extracted by mini-css-extract-plugin
export default {"container":"_2hjuQ","button":"_2230A","actionsContainer":"_27iBB","center":"_1AkMn","right":"_3jZcl","top":"_1MZjw","triangle":"_3TZ8w","fixedColor":"_3Cw5h"};